<!-- Small navbar artwork: one feature detail, drawn at its actual display size. -->
<template>
  <svg class="release-thumbnail" viewBox="0 0 72 56" fill="none" aria-hidden="true">
    <rect width="72" height="56" rx="8" :fill="palette.background" />
    <g v-if="entry.slug === 'our-own-email-system'">
      <rect x="8" y="10" width="33" height="38" rx="4" fill="white" />
      <rect x="12" y="16" width="25" height="13" rx="3" fill="#006cff" />
      <path d="M13 35h22m-22 5h16" stroke="#c4cdd9" stroke-width="2" stroke-linecap="round" />
      <rect x="37" y="6" width="27" height="39" rx="4" fill="white" stroke="#d9e1ec" />
      <rect x="40" y="12" width="21" height="25" rx="3" fill="#141f2f" />
      <circle cx="50.5" cy="20" r="4" stroke="#c9ad50" />
      <path d="M44 30h13" stroke="#c9ad50" stroke-width="2" stroke-linecap="round" />
    </g>
    <g v-else-if="entry.slug === 'gift-a-membership'">
      <rect x="8" y="8" width="56" height="40" rx="5" fill="white" />
      <path d="M14 16h17m-17 8h17m-17 9h12m-12 7h17" stroke="#BEC7D7" stroke-width="2" stroke-linecap="round" />
      <rect x="38" y="15" width="20" height="24" rx="4" fill="#813CFF" />
      <text x="48" y="30" text-anchor="middle" font-size="12" font-weight="600" fill="white">3</text>
      <path d="M41 43h14" stroke="#813CFF" stroke-width="2" stroke-linecap="round" />
    </g>
    <g v-else-if="entry.slug === 'shared-session-history'">
      <rect x="10" y="10" width="52" height="36" rx="5" fill="white" />
      <rect x="16" y="18" width="17" height="21" rx="3" fill="#F2F5F8" stroke="#E5EBF0" />
      <path d="M16 24h17" stroke="#E1E8EE" />
      <path d="M21 17v3m7-3v3" stroke="#95A6B4" stroke-linecap="round" />
      <text x="24.5" y="34" text-anchor="middle" fill="#45556A" font-size="9" font-weight="600">26</text>
      <path d="M39 22h16m-16 5h11" stroke="#BEC9D2" stroke-width="2" stroke-linecap="round" />
      <circle cx="42" cy="35" r="4" fill="#E8F3ED" />
      <path d="m40 35 1.3 1.3L44 33.5" stroke="#6B9B80" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round" />
    </g>
    <g v-else-if="['edit-and-reply-in-chat', 'chat-improvements'].includes(entry.slug)">
      <path d="M14 11h44a5 5 0 0 1 5 5v23H19a5 5 0 0 1-5-5Z" fill="#176AFF" />
      <rect x="19" y="16" width="37" height="11" rx="3" fill="#FFFFFF" fill-opacity=".22" />
      <path d="m25 19-3 2 3 2m-3-2h6m-6 11h26" stroke="#E8F0FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <rect x="40" y="35" width="17" height="11" rx="5.5" fill="white" stroke="#E3E5F0" />
      <path d="m47 38 1 2 2 .3-1.5 1.4.4 2-1.9-1-1.9 1 .4-2-1.5-1.4 2-.3Z" fill="#DAB769" />
    </g>
    <g v-else-if="entry.slug === 'voice-notes-in-chat'">
      <rect x="9" y="17" width="54" height="24" rx="7" fill="white" />
      <circle cx="22" cy="29" r="7" fill="#086AFF" />
      <path d="m20 25 5 4-5 4Z" fill="white" />
      <path d="M35 26v6m4-10v14m4-11v8m4-13v18m4-14v10m4-7v4" stroke="#82B0FA" stroke-width="2" stroke-linecap="round" />
    </g>
    <g v-else-if="entry.slug === 'growth-roadmap'">
      <path d="M13 10h35m-35 5h25" stroke="#E5D7FF" stroke-width="2" stroke-linecap="round" />
      <rect v-for="y in [22, 32, 42]" :key="y" x="10" :y="y" width="52" height="8" rx="3" fill="white" fill-opacity=".12" />
      <circle v-for="y in [26, 36, 46]" :key="y" cx="16" :cy="y" r="2.5" fill="#A97AFF" />
      <path d="M23 26h23m-23 10h20m-20 10h22" stroke="#E5D7FF" stroke-width="1.5" stroke-linecap="round" />
      <circle v-for="y in [26, 36, 46]" :key="y" cx="55" :cy="y" r="2.5" fill="#D4BDFF" />
    </g>
    <g v-else-if="entry.slug === 'support-widget'">
      <rect x="10" y="5" width="52" height="35" rx="6" fill="var(--color-white)" />
      <circle cx="20" cy="14" r="4" fill="var(--color-neutral-300)" /><circle cx="26" cy="14" r="4" fill="var(--color-neutral-400)" />
      <path d="M34 12h19m-19 5h14M18 24h35" stroke="var(--color-neutral-300)" stroke-width="2" stroke-linecap="round" />
      <rect x="17" y="30" width="38" height="5" rx="2" fill="var(--color-neutral-900)" />
      <rect x="10" y="43" width="31" height="9" rx="4.5" fill="var(--color-white)" /><circle cx="16" cy="47.5" r="2.5" fill="var(--color-neutral-400)" /><path d="M22 47.5h12" stroke="var(--color-neutral-500)" stroke-width="1.5" stroke-linecap="round" />
    </g>
    <g v-else-if="entry.slug === 'session-prep'">
      <rect x="10" y="8" width="52" height="41" rx="5" fill="var(--color-white)" />
      <path d="M15 8h42a5 5 0 0 1 5 5v6H10v-6a5 5 0 0 1 5-5" fill="var(--color-primary-500)" />
      <path d="M17 14h33" stroke="var(--color-white)" stroke-width="2" stroke-linecap="round" />
      <g v-for="y in [27, 39]" :key="y"><circle cx="19" :cy="y" r="4" fill="var(--color-primary-50)" /><path :d="`M29 ${y - 2}h24m-24 4h18`" stroke="var(--color-neutral-300)" stroke-width="1.5" stroke-linecap="round" /></g>
    </g>
    <g v-else-if="entry.slug === 'session-takeaways'">
      <rect x="14" y="7" width="44" height="43" rx="5" fill="white" />
      <path d="M23 16h25" stroke="#8C80B0" stroke-width="2" stroke-linecap="round" />
      <g v-for="y in [25, 35, 43]" :key="y"><circle cx="23" :cy="y" r="3" fill="#E0D7F1" /><path :d="`M31 ${y}h18`" stroke="#C4CBD6" stroke-width="2" stroke-linecap="round" /></g>
    </g>
    <g v-else-if="entry.slug === 'a-better-mentor-application'">
      <rect x="9" y="7" width="39" height="41" rx="5" fill="white" />
      <path d="M17 15h23M19 22v17" stroke="#D7DEE9" stroke-width="1.5" stroke-linecap="round" />
      <circle cx="19" cy="23" r="3" fill="#141F2F" /><circle cx="19" cy="32" r="3" fill="#006CFF" />
      <path d="M26 23h13m-13 9h10m-10 8h12" stroke="#BEC7D7" stroke-width="2" stroke-linecap="round" />
      <rect x="38" y="24" width="26" height="26" rx="4" fill="white" stroke="#DAEAFF" />
      <path d="M43 31h16" stroke="#98A2B2" stroke-width="2" stroke-linecap="round" />
      <rect x="43" y="36" width="6" height="7" rx="2" fill="#006CFF" /><rect x="52" y="36" width="6" height="7" rx="2" fill="#E8F1FE" />
    </g>
    <g v-else-if="entry.slug === 'better-mentor-matching'">
      <rect x="8" y="8" width="56" height="40" rx="5" fill="white" />
      <rect x="14" y="14" width="44" height="9" rx="3" fill="#E8F1FE" /><path d="M19 18.5h32" stroke="#92BEFF" stroke-width="1.5" stroke-linecap="round" />
      <g v-for="x in [21, 36, 51]" :key="x"><circle :cx="x" cy="33" r="5" fill="#BCD8FF" /><path :d="`M${x - 5} 42h10`" stroke="#98A2B2" stroke-width="1.5" stroke-linecap="round" /></g>
    </g>
    <g v-else-if="entry.slug === 'a-clearer-session-flow'">
      <rect x="10" y="11" width="52" height="35" rx="5" fill="white" /><path d="M17 20h13m12 0h13m-38 6h10m15 0h10" stroke="#B9CBE4" stroke-width="2" stroke-linecap="round" /><path d="m34 22 5 3-5 3" stroke="#086AFF" stroke-linecap="round" stroke-linejoin="round" /><rect x="18" y="33" width="36" height="7" rx="3" fill="#DBECE3" />
    </g>
    <g v-else-if="entry.slug === 'the-new-site-is-live'">
      <rect x="8" y="6" width="24" height="13" rx="3" fill="#FFFFFF99" /><rect x="40" y="6" width="24" height="13" rx="3" fill="#FFFFFF99" />
      <text x="20" y="15" text-anchor="middle" font-size="7" font-weight="600" fill="#466C5F">www</text><text x="52" y="15" text-anchor="middle" font-size="7" font-weight="600" fill="#466C5F">app</text>
      <path d="M20 20v5h32v-5m-16 5v7m-3-3 3 3 3-3" stroke="#699A85" stroke-linecap="round" stroke-linejoin="round" />
      <rect x="8" y="35" width="56" height="15" rx="4" fill="white" /><text x="36" y="45" text-anchor="middle" font-size="7" font-weight="600" fill="#183D32">www.growthmentor.com</text>
    </g>
    <g v-else-if="entry.slug === 'give-feedback'">
      <rect x="8" y="8" width="39" height="40" rx="5" fill="white" />
      <g v-for="y in [17, 25, 33, 41]" :key="y"><rect x="14" :y="y - 2" width="5" height="5" rx="1.5" fill="#E7EBF1" /><path :d="`M23 ${y}h16`" stroke="#98A2B2" stroke-width="2" stroke-linecap="round" /></g>
      <rect x="37" y="24" width="27" height="27" rx="4" fill="white" stroke="#DAEAFF" /><path d="M43 31h15m-15 5h12" stroke="#BEC7D7" stroke-width="2" stroke-linecap="round" /><rect x="43" y="41" width="15" height="5" rx="2" fill="#006CFF" />
    </g>
    <image
      v-else-if="entry.slug === 'im-building-growthmentor-myself-now' && entry.screenshot"
      :href="entry.screenshot"
      width="72"
      height="56"
      preserveAspectRatio="xMidYMid slice"
      clip-path="inset(0 round 8px)"
    />
    <g v-else>
      <rect x="10" y="11" width="52" height="34" rx="5" fill="white" />
      <rect x="15" y="16" width="42" height="11" rx="3" stroke="#A48BC9" />
      <circle cx="21" cy="21" r="2" stroke="#9B83BD" />
      <path d="m22.5 22.5 2 2M29 21h21" stroke="#BAACCC" stroke-linecap="round" />
      <rect x="28" y="32" width="17" height="6" rx="2" fill="#F4E4A5" />
      <path d="M16 35h10m21 0h8" stroke="#C0CEC5" stroke-width="2" stroke-linecap="round" />
    </g>
  </svg>
</template>
<script setup lang="ts">
import { computed } from 'vue'
// The navbar panel passes a trimmed row, so only the slug is required.
const props = defineProps<{ entry: { slug: string } }>()
const palette = computed(() => ({ background: ({
  'gift-a-membership': '#D4BDFF',
  'shared-session-history': '#EDF3F5',
  'edit-and-reply-in-chat': '#F0EDFA',
  'voice-notes-in-chat': '#EEF3FA',
  'growth-roadmap': '#1A0D2E',
  'chat-improvements': '#F0EDFA',
  'support-widget': 'var(--color-neutral-100)',
  'session-prep': 'var(--color-primary-50)',
  'session-takeaways': 'var(--color-secondary-50)',
  'a-better-mentor-application': '#006CFF',
  'better-mentor-matching': '#003480',
  'a-clearer-session-flow': '#EAF2FB',
  'the-new-site-is-live': '#C9ECDE',
  'give-feedback': '#006CFF',
} as Record<string, string>)[props.entry.slug] || '#EDF4F1' }))
</script>
<style scoped>
.release-thumbnail { display: block; width: 72px; height: 56px; flex-shrink: 0; }
</style>
